<template>
  <div>
    <div class="loader" v-show="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-show="!loader" id="report" class="report"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import * as pbi from 'powerbi-client';

export default {
  name: 'ReportPbi',
  computed: {
    ...mapState('users', ['user']),
  },
  props: {
    reportId: {
      type: String,
      required: true,
    },
    groupId: {
      type: String,
      required: true,
    },
    filterPaneEnabled: {
      type: Boolean,
      default: false,
    },
    pageNavigation: {
      type: Boolean,
      default: false,
    },
    rls: {
      type: Boolean,
      default: false,
    },
    pageName: {
      type: String,
    },
    usernameReport: {
      type: String,
    },
  },
  data: () => ({
    userAuth: null,
    loader: true,
    embedUrl: null,
    embedToken: null,
    report: null,
    container: null,
  }),
  methods: {
    ...mapActions('users', ['getUser']),
    async embedPowerBi() {
      // eslint-disable-next-line
      const models = pbi.models;
      const permissions = models.Permissions.All;
      // eslint-disable-next-line
      powerbi.embed(this.container, {
        type: 'report',
        id: this.report,
        embedUrl: `${this.embedUrl}`,
        tokenType: models.TokenType.Embed,
        accessToken: this.embedToken,
        permissions,
        settings: {
          filterPaneEnabled: this.filterPaneEnabled,
          navContentPaneEnabled: false,
          panes: {
            pageNavigation: {
              visible: this.pageNavigation,
            },
          },
        },
      });
    },
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getUser({
      token: this.userAuth.token,
      userId: this.userAuth._id,
    });

    this.container = document.getElementById('report');
    const url = `https://powerbi.idcx-verse.com/?reportId=${
      this.reportId
    }&groupId=${this.groupId}${
      this.rls
        ? `&roles=SecurityLevel&credentials=true&accessLevel=View&usernameReport=${this.userAuth.email}`
        : ''
    }`;
    axios
      .get(url)
      // eslint-disable-next-line
      .then((response) => {
        this.loader = false;
        this.embedUrl = response.data.EmbedURL;
        this.embedToken = response.data.EmbedToken;
        this.report = response.data.ReportId;
        this.embedPowerBi();
      })
      .catch((err) => {
        window.console.log(err);
      });
  },
};
</script>
<style lang="scss" scoped>
.report {
  height: calc(100vh - 73px);
  max-height: calc(100vh - 73px);
  iframe {
    display: block;
    border: none;
    height: 100vh;
    width: 100vw;
  }
}
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/report-pbi/index.vue